
/* styles */
require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-2186c078&scoped=true!sass-loader?sourceMap!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Onboarding.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/onboarding.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-2186c078!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/onboarding.pug"),
  /* scopeId */
  "data-v-2186c078",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Onboarding.vue
// module id = 1334
// module chunks = 1